<template>
  <canvas ref="qrCanvas" :width="props.size" :height="props.size"></canvas>
</template>

<script setup>
import { ref, onMounted, defineProps, computed } from 'vue';
import QRCode from 'qrcode-generator';

const props = defineProps({
  text: {
    type: String,
    required: true
  },
  size: {
    type: Number,
    default: 120
  }
});

const qrCanvas = ref(null);

const qrCodeInstance = computed(() => {
  const qr = QRCode(0, 'L');
  qr.addData(props.text);
  qr.make();
  return qr;
});

onMounted(() => {
  const qr = qrCodeInstance.value;
  const ctx = qrCanvas.value.getContext('2d');
  const cellSize = props.size / qr.getModuleCount();

  for (let row = 0; row < qr.getModuleCount(); row++) {
    for (let col = 0; col < qr.getModuleCount(); col++) {
      ctx.fillStyle = qr.isDark(row, col) ? '#000' : '#fff';
      ctx.fillRect(col * cellSize, row * cellSize, cellSize, cellSize);
    }
  }
});
</script>

<style scoped>
canvas {
  /* 如果之前有 width 或 height 的样式设置，这里可以移除 */
  /* width: auto;
  height: auto; */
}
</style>